/**
 * Admin surface shell (Phase 6). Lives inside the reviewer dashboard, reuses the same
 * design system (Tile/Button/Chip - see ../../components/ui.tsx), gated by
 * profile.isAdmin at the router level (see ../reviewer/ReviewerApp.tsx). See ADMIN.md
 * for what each tab edits and how re-runs/rollbacks work.
 */
import type { AdminSection } from '../../reviewer/router';
import { Button } from '../../components/ui';
import { CheckSchemaAdmin } from './CheckSchemaAdmin';
import { RiskMatrixAdmin } from './RiskMatrixAdmin';
import { ErrorsConfigAdmin } from './ErrorsConfigAdmin';
import { StandingInstructionsAdmin } from './StandingInstructionsAdmin';
import { AgentConfigAdmin } from './AgentConfigAdmin';
import { AuditLogPanel } from './AuditLogPanel';

const TABS: Array<{ section: AdminSection; label: string }> = [
  { section: 'checks', label: 'Checks' },
  { section: 'risks', label: 'Risk matrix' },
  { section: 'errors', label: 'Errors' },
  { section: 'instructions', label: 'Standing instructions' },
  { section: 'config', label: 'Agent config' },
  { section: 'audit', label: 'Audit log' },
];

interface AdminAppProps {
  section: AdminSection;
  onNavigateSection: (section: AdminSection) => void;
}

export function AdminApp({ section, onNavigateSection }: AdminAppProps) {
  return (
    <main className="main main--wide">
      <div className="page-head">
        <h1 className="page-title">Admin</h1>
      </div>

      <div className="admin-tabs">
        {TABS.map((tab) => (
          <Button
            key={tab.section}
            variant={section === tab.section ? 'primary' : 'secondary'}
            onClick={() => onNavigateSection(tab.section)}
          >
            {tab.label}
          </Button>
        ))}
      </div>

      <div className="stack" style={{ marginTop: 'var(--space-5)' }}>
        {section === 'checks' ? <CheckSchemaAdmin /> : null}
        {section === 'risks' ? <RiskMatrixAdmin /> : null}
        {section === 'errors' ? <ErrorsConfigAdmin /> : null}
        {section === 'instructions' ? <StandingInstructionsAdmin /> : null}
        {section === 'config' ? <AgentConfigAdmin /> : null}
        {section === 'audit' ? <AuditLogPanel /> : null}
      </div>
    </main>
  );
}
